import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// sections
import TableRow from './TableRow';
import Form from './Form';
// components
import Breadcrumbs from '../../../components/breadcrumbs';
import SearchField from '../../../components/search-field';
import Pagination from '../../../components/pagination';
import { Dialog } from '../../../components/dialog';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// styles
import { Content, Box, AffiliatedTitle, SearchWrapper, AddButton } from '../../../styles';
// apis
import { getTestCases, deleteTestCases } from '../../../apis';

// ----------------------------------------------------------------------

const sizes = [ 20, 30 ];

// ----------------------------------------------------------------------

export default function TestCasePage() {
  const navigate  = useNavigate();

  const state = useLocation().state;
  const group = state?.group;

  const [ data, setData ] = useState({ content: [], totalPages: 0 });
  const { content: rows, totalPages: pages } = data;

  const [ keyword, setKeyword ] = useState('');
  const [ page, setPage ] = useState(0);
  const [ size, setSize ] = useState(20);
  
  const [ dialog, setDialog ] = useState({
    delete: { visible: false },
    form: { visible: false }
  });

  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    if ( !state ) return navigate(-1);
    handleReset();
    // eslint-disable-next-line
  }, [state]);

  const handlePage = (value) => {
    setPage(value - 1);
    getTestCases(setData, group.id, keyword, value-1, size);
  };

  const handleSize = (event) => {
    setPage(0);
    setSize( Number(event.target.value) );
    getTestCases(setData, group.id, keyword, 0, Number(event.target.value));
  };

  const handleSearch = () => {
    setPage(0);
    getTestCases(setData, group.id, keyword, 0, size);
  };

  const handleDelete = async () => {
    await deleteTestCases(dialog.delete.id)
      .then(() => {
        handleSearch();
        setDialog({ ...dialog,
          delete: { visible: false }
        });
      })
      .catch(() => {
        setMessage('테스트 케이스를 삭제할 수 없습니다. 나중에 다시 시도해 주세요.');
      });
  };

  const handleReset = async () => await getTestCases(setData, group.id, keyword, page, size);

  if ( !state ) return;

  return (
    <Content>
      <Breadcrumbs
        heading='테스트 케이스 관리'
        links={[
          { name: '시스템 관리' },
          { name: '부식 전위 그룹 관리', link: '/system/potential-group' },
          { name: '테스트 케이스 관리' }
        ]}
      />

      <Box>
        <AffiliatedTitle>
          <p>{ group.name }</p>
          <span>{ group.description }</span>
        </AffiliatedTitle>

        <SearchWrapper>
          <SearchField
            value={keyword}
            onChange={setKeyword}
            handleSearch={handleSearch}
            handleInitialize={handleSearch}
            placeholder='테스트 케이스를 입력하세요.'
          />

          <AddButton onClick={() => {
            setDialog({ ...dialog,
              form: {
                visible: true,
                id: group.id,
                type: 'create'
              }
            });
          }}>
            등록
          </AddButton>
        </SearchWrapper>

        <DataGrid
          dataSource={rows}
          noDataText=''
          columnAutoWidth={true}
          dataRowRender={({data}) => <TableRow row={data} dialog={dialog} setDialog={setDialog} group={group} />}
        >
          <Column caption='번호' dataField='number' alignment='center' />
          <Column caption='테스트 케이스' dataField='name' alignment='center' />
          <Column caption='등록일' dataField='createdAt' alignment='center' />
          <Column />
        </DataGrid>

        <Pagination page={page} pages={pages} handlePage={handlePage} size={size} sizes={sizes} handleSize={handleSize} />

        { dialog.delete.visible &&
          <Dialog
            title='테스트 케이스 삭제'
            icon='delete'
            message={message}
            actions={
              <div>
                <button onClick={() => handleDelete()}>
                  삭제
                </button>
                <button onClick={() => {
                  setDialog({ ...dialog,
                    delete: { visible: false }
                  });
                  setMessage(null);
                }}>
                  취소
                </button>
              </div>
            }
          >
            <p>선택하신 테스트 케이스를 삭제하시겠습니까?</p>
          </Dialog>
        }

        { dialog.form.visible &&
          <Form dialog={dialog} setDialog={setDialog} handleReset={handleReset} />
        }
        
      </Box>
    </Content>
  );
}